import React from "react";
import PropTypes from "prop-types";

import { Field, Control, Select, Icon } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SystemCodes from "./SystemCodes";
import { ErrorMessage } from "../ErrorMessage";

const SystemCodeCodeNameSelect = ({
  value,
  label,
  size,
  name,
  onChange,
  icon,
  where,
  required
}) => (
  <Field>
    <SystemCodes
      variables={{
        where,
        orderByMulti: ["CodeName_ASC"]
      }}
    >
      {({ data, loading, error }) => {
        if (error) return <ErrorMessage error={error} />;
        const codes = data ? data.SystemCodes : null;
        return codes ? (
          <Control iconLeft size={size}>
            <Select.Container
              fullwidth
              color={
                error || (required && (value === "" || value === "0"))
                  ? "danger"
                  : "secondary"
              }
              size={size}
              state={loading ? "loading" : null}
            >
              <Select
                name={name}
                required={required}
                value={value}
                onChange={onChange}
              >
                <Select.Option value={0}>{label}</Select.Option>
                {!loading &&
                  [...new Set(data.SystemCodes.map(c => c.CodeName))].map(
                    (CodeId, i) => (
                      <Select.Option
                        key={`system-code-id-select-${i}`}
                        value={CodeId}
                      >
                        {CodeId}
                      </Select.Option>
                    )
                  )}
              </Select>
            </Select.Container>
            {icon && (
              <Icon align="left" size={size}>
                <FontAwesomeIcon icon={icon} />
              </Icon>
            )}
          </Control>
        ) : null;
      }}
    </SystemCodes>
  </Field>
);

SystemCodeCodeNameSelect.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  onChange: PropTypes.func,
  label: PropTypes.string,
  size: PropTypes.string,
  icon: PropTypes.string,
  where: PropTypes.object,
  required: PropTypes.bool
};

SystemCodeCodeNameSelect.defaultProps = {
  value: 0,
  icon: "globe",
  where: {}
};
export default SystemCodeCodeNameSelect;
